import type { Environment } from '@/core/lib/env/env.context';
import { ACTUAL_ENV, valuesFromProcess } from '@/core/lib/env/env.context';
import { ApiVersions } from '@/core/lib/fetch';
import api from '@/core/lib/fetch/api';
import { InterestListResult, interestListResult, Interests } from '@/core/types/interests';

const getUrl = () => valuesFromProcess[ACTUAL_ENV as Environment]?.DONNONS_API_URL;

const query = {
  get: async (token: string) => {
    return api.get<InterestListResult>({
      url: `${getUrl()}${ApiVersions.V1}/user/interests`,
      schema: interestListResult,
      token,
    });
  },
};

const mutation = {
  put: async (data: { interests: Interests }, token: string) => {
    return api.put<null, { interests: Interests }>({
      url: `${getUrl()}${ApiVersions.V1}/user/interests`,
      data,
      schema: undefined,
      token,
    });
  },
};

export default { query, mutation };
